import { FC, useEffect, useRef, useState } from 'react';
import styles from '../../assets/scss/ImageSlider/ImageSlider.module.scss';

export const ImageSlider: FC<{ images: { url: string }[] }> = ({ images }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const thumbnailRefs = useRef<(HTMLImageElement | null)[]>([]);

  // サムネイルが切り替わったら自動でスクロール
  useEffect(() => {
    const target = thumbnailRefs.current[selectedIndex];
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
      });
    }
  }, [selectedIndex]);

  return (
    <div className={styles.container}>
      <div className={styles.mainImageContainer}>
        <img
          className={styles.mainImage}
          src={images[selectedIndex].url}
          alt=""
        />
        <button
          className={`${styles.navButton} ${styles.prevButton}`}
          onClick={() => setSelectedIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1))}
        />
        <button
          className={`${styles.navButton} ${styles.nextButton}`}
          onClick={() => setSelectedIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1))}
        />
      </div>

      <div className={styles.thumbnailSlider}>
        {images.map((image, index) => (
          <img
            key={index}
            ref={(el) => {
              thumbnailRefs.current[index] = el;
            }}
            className={`${styles.thumbnail} ${selectedIndex === index ? styles.active : ''}`}
            src={image.url}
            alt=""
            onClick={() => setSelectedIndex(index)}
          />
        ))}
      </div>
    </div>
  );
};
